import { initReactI18next } from 'react-i18next';

import { I18N_OPTIONS } from 'apps/promo/helpers/i18Options';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-http-backend';

const isBrowser = typeof window !== 'undefined';

i18n.use(initReactI18next);

if (isBrowser) {
    // only the browser should rely on the XHR backend + detector
    i18n.use(XHR).use(LanguageDetector);

    // initialize if not already initialized
    if (!i18n.isInitialized) {
        i18n.init(I18N_OPTIONS);
    }
}

export default i18n;
